import { DATA_UPLOAD_OPTIONS } from 'constants/reports.constants';
import { ReportRunHistory } from 'model/types';
import { createReport } from 'services';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type IReportStore = {
  report: any;
  // eslint-disable-next-line prettier/prettier, @typescript-eslint/no-empty-object-type
  updateReportState: (report_State_Object: any) => {};
  isReportLoading: boolean;
  error?: string;
  resetReportNameError: () => void;
  setIsReportCreated: (isReport: boolean) => void;
  storePrevReportData: any;
  isReportCreated: boolean;
  isReportRerun: string | null;
  selectedExistingRun: ReportRunHistory | null;
  reportRunHistory: ReportRunHistory[];
  setReportRunHistory: (history: ReportRunHistory[]) => void;
  setSelectedExistingRun: (run: ReportRunHistory | null) => void;
  setIsReportRerun: (isRerun: string | null) => void;
  resetStore: () => void;
  updateReportId: (reportId: number | string) => void;
  setError: (error: string) => void;
  selectedDataUploadOption: string;
  setSelectedDataUploadOption: (option: string) => void;
};

//  needs to be optimized
export const useCreateReportStore = create<IReportStore, [['zustand/persist', unknown]]>(
  persist(
    (set, get) => ({
      report: {},
      reportRunHistory: [],
      isReportCreated: false,
      isReportRerun: null,
      selectedExistingRun: null,
      selectedDataUploadOption: DATA_UPLOAD_OPTIONS.UPLOAD_NEW,
      setReportRunHistory: (history: ReportRunHistory[]) => set({ reportRunHistory: history }),
      setSelectedDataUploadOption: (option: string) => set({ selectedDataUploadOption: option }),
      setSelectedExistingRun: (run: ReportRunHistory | null) => set({ selectedExistingRun: run }),
      updateReportState: async (props: any) => {
        try {
          const response: any = await createReport(props);
          const { responseCode, data, responseMessage } = response;
          if (responseCode === 200) {
            set({ report: data, error: '', isReportCreated: true });
          } else if (responseCode === 500) {
            set({ report: {}, error: responseMessage, isReportCreated: false });
          }
          return response;
        } catch (error: any) {
          console.error('Failed to fetch countries', error);
          const reportServerMsg =
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            error?.message ||
            String(error);
          set({ error: reportServerMsg, isReportCreated: false });
          return error;
        }
      },
      resetReportNameError: () => set({ error: '', isReportCreated: false }),
      setError: (error: string) => set({ error: error }),
      setIsReportCreated: (isReport: boolean) => set({ isReportCreated: isReport }),
      setIsReportRerun: (isRerun: string | null) => set({ isReportRerun: isRerun }),
      updateReportId: (reportId: number | string) => {
        const prevData = get().report;
        set({ report: { ...prevData, reportId: reportId } });
      },
      storePrevReportData: (data: any) => {
        set({ report: data, error: '' });
      },
      isReportLoading: false,
      resetStore: () =>
        set({
          error: '',
          report: {},
          isReportCreated: false,
          isReportRerun: null,
          isReportLoading: false,
          selectedDataUploadOption: DATA_UPLOAD_OPTIONS.UPLOAD_NEW,
          selectedExistingRun: null,
          reportRunHistory: [],
        }),
    }),
    {
      name: 'kf1-createReport', // name of the item in the storage (must be unique)
      storage: createJSONStorage(() => window.sessionStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);
